import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react"
// import { Transition } from "react-transition-group"
import gsap from "gsap"
// import { Link } from "gatsby"
// import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"

import style from "./index.module.css"

import Container from "../hoc/container/Container"
import Header from "../components/header/Header"
import RegistrationForm from "../components/registrationForm/RegistrationForm"
import Button from "../components/ui/button/Button"
import Phone from "../components/phone/Phone"
import HeadingBlock from "../components/headingBlock/HeadingBlock"
import Background from "../components/background/Background"
import BenefitsBanner from "../components/benefitsBanner/BenefitsBanner"

import HeaderPhone from "../components/phone/HeaderPhone"
import Footer from "../components/footer/Footer"

import WindowContext from "../contexts/WindowContext"

const headerColours = {
  cyan: "#09CCC4",
  purple: "#BB6BD9",
  yellow: "#FFB300",
  red: "#EB5757",
}

const IndexPage = props => {
  const [headerColourIndex, setHeaderColourIndex] = useState(0)
  const [sectionTopPositions, setSectionTopPositions] = useState([])
  const [sectionIndex, setSectionIndex] = useState(-1)
  const personalSection = useRef()
  const matchesSection = useRef()
  const buddiesSection = useRef()

  const windowDimensions = useContext(WindowContext)

  useEffect(() => {
    window.scrollTo(0, 0)
    setSectionTopPositions(returnSectionTopPositions())
  }, [])

  useEffect(() => {
    setTimeout(() => {
      // TODO: Optimise this to only occur below 200vh scroll or ..
      const newIndex = headerColourIndex + 1 < 4 ? headerColourIndex + 1 : 0
      setHeaderColourIndex(newIndex)
      const newColour = Object.values(headerColours)[newIndex]
      gsap.to("#headerColourSpan", {
        duration: 0.5,
        color: newColour,
      })
    }, 4000)
  }, [headerColourIndex])

  useEffect(() => {
    // console.log("Section Top Positions:", sectionTopPositions)
    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => {
      window.removeEventListener("scroll", handleScroll, { passive: true })
    }
  }, [sectionTopPositions])

  const handleScroll = useCallback(() => {
    const scrollY = window.scrollY
    window.requestAnimationFrame(() => {
      if (scrollY < sectionTopPositions[0]) {
        setSectionIndex(-1)
      } else if (
        scrollY > sectionTopPositions[0] &&
        scrollY < sectionTopPositions[1]
      ) {
        setSectionIndex(0)
      } else if (
        scrollY > sectionTopPositions[1] &&
        scrollY < sectionTopPositions[2]
      ) {
        setSectionIndex(1)
      } else if (scrollY > sectionTopPositions[2]) {
        setSectionIndex(2)
      }
    })
  }, [sectionTopPositions])

  const returnSectionTopPositions = useCallback(
    () => [
      personalSection.current.offsetTop - window.innerHeight + 100,
      matchesSection.current.offsetTop - window.innerHeight + 100,
      buddiesSection.current.offsetTop - window.innerHeight + 100,
    ],
    []
  )

  return (
    <>
      <SEO title="Join Fufil" />
      {/* Header and First Section */}
      <Header
        colour={Object.values(headerColours)[headerColourIndex]}
        windowDimensions={windowDimensions}
      />
      {/* Personal Section */}
      <section ref={personalSection} className={style.section}>
        <Container containerStyle={{ margin: "32px 0px 0px 0px" }}>
          <h2>
            Your Growth. <span id="headerColourSpan">Your Colour.</span>
          </h2>
          <h3 style={{ margin: "16px 0 32px 0", fontWeight: 600 }}>
            Create a personal life wheel and success system.
            <br />
            Personalise your app with any colour!
          </h3>
        </Container>
        <HeaderPhone colour={Object.keys(headerColours)[headerColourIndex]} />
        <BenefitsBanner index={0} />
      </section>

      {/* Background */}
      <Background
        windowDimensions={windowDimensions}
        sectionIndex={sectionIndex}
      />

      {/* Matches Section */}
      <section ref={matchesSection} className={style.section}>
        <HeadingBlock index={1} />
        <Phone index={1} />
        <BenefitsBanner index={1} />
      </section>

      {/* Buddies Section */}
      <section ref={buddiesSection} className={style.section}>
        <HeadingBlock index={2} />
        <Phone index={2} />
        <BenefitsBanner index={2} />
      </section>
    </>
  )
}

export default IndexPage
